<template>
  <div class="data-receiving-stat">
<!--    <a-row type="flex" :gutter="30">-->
<!--      <a-col flex="1">-->
<!--        <div class="block-wrapper">-->
<!--          <a-row type="flex">-->
<!--            <a-col flex="1">-->
<!--              <h3>Количество загруженных данных</h3>-->
<!--            </a-col>-->
<!--            <a-col>-->
<!--              <date-picker-->
<!--                style="width: 100%; min-width: 250px; height: 40px;"-->
<!--                label="Дата:"-->
<!--                :value="downloaded_date"-->
<!--                :enabledDatesArray="downloaded_dates"-->
<!--                format="YYYY-MM-DD"-->
<!--                class="white-date-picker"-->
<!--                @input="downloaded_date = $event"-->
<!--              />-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--          <v-chart class="chart" :option="pie" :initOptions="initOptions" />-->
<!--&lt;!&ndash;          <button @click="refresh">Refresh</button>&ndash;&gt;-->
<!--        </div>-->
<!--      </a-col>-->
<!--      <a-col flex="1">-->
<!--        <div class="block-wrapper">-->
<!--          <a-row type="flex">-->
<!--            <a-col flex="1">-->
<!--              <h3>Динамика изменения размера файла</h3>-->
<!--            </a-col>-->
<!--            <a-col>-->
<!--                <input-enum-->
<!--                  v-model="year"-->
<!--                  :options="years"-->
<!--                  type="string"-->
<!--                  label="Год"-->
<!--                  :allowClear="false"-->
<!--                  style="min-width: 250px;"-->
<!--                />-->
<!--            </a-col>-->
<!--          </a-row>-->

<!--          <v-chart class="chart" :option="sizeDynamicChartOptions" :initOptions="initOptions" />-->
<!--        </div>-->
<!--      </a-col>-->
<!--    </a-row>-->

    <h2>Инциденты</h2>

    <a-row type="flex" :gutter="10" class="filters">
      <a-col>
        <date-picker
          style="width: 100%; min-width: 250px; height: 40px;"
          label="Дата:"
          :value="downloaded_date"
          :enabledDatesArray="downloaded_dates"
          format="YYYY-MM-DD"
          class="gray-date-picker"
          @input="downloaded_date = $event"
        />
      </a-col>
      <!--      <a-col>-->
      <!--        <a-select defaultValue="null" size="large">-->
      <!--          <a-select-option value="null"> Тип инцидента</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-col>-->
    </a-row>

    <div class="block-wrapper">
      <a-table
        :class="['table']" :columns="columns" :data-source="rows"
        :pagination="false"
      />
    </div>
  </div>
</template>

<script>
import VChart from 'vue-echarts';

import axios from "axios";
import InputEnum from "@/components/base/InputEnum";
import DatePicker from "@/components/base/DatePicker"
import {storage} from "@/helpers";

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;
const esUrl = process.env.VUE_APP_ELASTIC_URL;

export default {
  name: 'DataReceivingStat',
  components: {
    VChart,
    InputEnum,
    DatePicker
  },

  data: () => ({
    pie: {},
    initOptions: {
      renderer: "canvas"
    },
    columns: [
      {
        title: 'Тип инцидента',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: 'Количество',
        dataIndex: 'amount',
        key: 'amount',
      },
    ],
    rows: [],
    dataAmountChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        right: 0,
        top: 'center',
        data: ['Загружено данных за все время', 'Из них удалено'],
      },
      series: [
        {
          type: 'pie',
          radius: ['50%', '80%'],
          center: ['17%', '50%'],
          data: [
            { value: 22425600, name: 'Загружено данных за все время' },
            { value: 2242560, name: 'Из них удалено' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },
    sizeDynamicChartOptions: {
      xAxis: {
        type: 'category',
        data: [`2 фев`, '14 мар', '4 апр', '23 июн', '2 авг', '19 сен', '2 дек']
      },
      yAxis: {},
      series: [
        {
          data: [820, 932, 901, 934, 1290, 1330, 1320],
          type: 'line',
          smooth: true,
        },
      ],
    },
    downloaded_date: '',
    downloaded_dates: [],
    years: ['2019','2020','2021','2022'],
    year: '',
    data: {
      'downloaded_data': '',
      'file_size_dynamics': '',
      'incidents': ''
    },
    loaded_chart: false
  }),
  watch: {
    downloaded_date(){
      storage.set('dateFilter', this.downloaded_date)
      this.refetch_date()
      this.refresh()
    },
    year(){
      storage.set('yearFilter', this.year)
      this.refetch_filesize()
    }
  },
  async mounted() {
    this.year = storage.get('yearFilter') || this.years[0]
    this.pie = this.getPie();
    this.downloaded_date = storage.get('dateFilter') || this.downloaded_date
    const index = 'catalog_pull_data'
    await this.axios
      .get(`${apiUrl}/report/get_list_date_statistic?index=${index}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
      .then(({data}) => {
        this.downloaded_dates = data.sort()
        if (!this.downloaded_date) {
          this.downloaded_date = this.downloaded_dates[0];
        }
      })
      .catch((err) => {
        throw err;
      })
  },
  methods: {
    refetch_filesize(){
      this.sizeDynamicChartOptions = {
        xAxis: {
          type: 'category',
        },
        yAxis: {},
        series: [
          {
            data: [this.random(), this.random(), this.random(), this.random(), this.random(), this.random(), this.random()],
            type: 'line',
            smooth: true,
          },
        ],
      }
    },
    random() {
      return Math.round(300 + Math.random() * 700) / 10;
    },
    getPie() {
      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          right: 0,
          top: 'center',
          data: ['Загружено данных за все время', 'Из них удалено'],
        },
        series: [
          {
            type: 'pie',
            radius: ['50%', '80%'],
            center: ['17%', '50%'],
            data: [
              {value: this.random(), name: 'Загружено данных за все время'},
              {value: this.random(), name: 'Из них удалено'},
            ],
            labelLine: {
              show: false,
            },
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
    },
    refresh() {
      this.pie = this.getPie();
    },
    async refetch_date(){
      this.loaded_chart = true
      this.dataRequest = axios.CancelToken.source();
      const query = {
        size: 1000,
        query: {
          term: {
            "date": this.downloaded_date,
          },
        },
      };
      await axios
        .post(`${esUrl}/catalog_pull_data/_search`, query)
        .then(({data}) => {
          this.downloaded_report = data.hits.hits[0]._source;
          this.dataAmountChartOptions.series.data = [
            { value: this.downloaded_report.loaded || 0, name: 'Загружено данных за все время' },
            { value: this.downloaded_report.delited || 0, name: 'Из них удалено' },
          ]
          this.rows=[]
          Object.keys(this.downloaded_report.errors).forEach((key)=>{
            this.rows.push({'type': key, 'amount': `${this.downloaded_report.errors[key].count} (${this.downloaded_report.errors[key].procent}%)`})
          })
          this.loaded_chart = false

        })
        .catch((error) => {
          this.$notification.error({
            message: `Не удалось получить данные. Обратитесь к администратору.`,
          });
          this.dataAmountChartOptions.series.data = []
          setTimeout(function () {
            this.loaded_chart = false
          }, 1000)
          throw error
        })
    },
  }
};
</script>

<style lang="scss">
.data-receiving-stat {
  .block-wrapper {
    .line-list {
      background: #ecf1f8;
      color: #71829b;

      > *:not(:first-child):before {
        background: #dae3f0;
      }
    }
  }

  .ant-calendar-picker.gray-date-picker input {
    background: #ecf1f8;
    color: #71829b;
    border: none;
    font-size: 14px !important;
  }
  .ant-calendar-picker.white-date-picker input {
    border: none;
    font-size: 14px !important;
  }

  .chart {
    margin-top: 30px;
    height: 200px;
  }
}
</style>
